var map = {
	"./arrow-right.svg": 74811,
	"./battery-full.svg": 3332,
	"./battery.svg": 61512,
	"./btn-add-invert.svg": 26447,
	"./btn-add.svg": 37442,
	"./btn-info.svg": 16703,
	"./desktop-only.svg": 4194,
	"./grass.svg": 20911,
	"./hourglass.svg": 31603,
	"./icon-arrow-left.svg": 96464,
	"./icon-arrow-right.svg": 6748,
	"./icon-caret-left.svg": 24796,
	"./icon-caret-right.svg": 42739,
	"./icon-caret.svg": 97936,
	"./icon-checkbox.svg": 98114,
	"./icon-triangle-up.svg": 83695,
	"./icon-triangle.svg": 24089,
	"./info.svg": 75116,
	"./lely-bg-arrow-dsktp.svg": 68685,
	"./lely-bg-arrow.svg": 70714,
	"./lely-bg-extended-point.svg": 28568,
	"./lely-bg-masked.svg": 36113,
	"./lely-bg-point.svg": 84642,
	"./location.svg": 40123,
	"./logo-lely.svg": 51922,
	"./no-tasks.svg": 7388,
	"./scale.svg": 98703,
	"./schedule.svg": 17772,
	"./speed.svg": 28138,
	"./straighten.svg": 43070
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 87254;